import React from 'react'

const LoginUserPermissions = ({user}) => {
  return (
    <p key={user.id} className='flex w-full justify-center items-center text-center text-gray-500 h-10 text-xs'>{user.name}</p>    
    )
}

export default LoginUserPermissions